"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

function hasChecked(object) {
  return 'checked' in object;
}

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      onUpdate = _ref.onUpdate,
      qaClasses = _ref.qaClasses,
      checked = _ref.checked,
      disabled = _ref.disabled,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      key = _ref.key;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('topic-creator__sidebar--checkbox checkbox', customClass),
    key: key !== null && key !== void 0 ? key : undefined
  }, (0, _preact.h)("label", null, (0, _preact.h)("input", {
    type: "checkbox",
    className: qaClasses,
    checked: checked,
    disabled: disabled,
    onChange: function onChange(e) {
      if (e.target && hasChecked(e.target)) {
        onUpdate(e.target.checked);
      }
    }
  }), label));
};

var _default = Checkbox;
exports.default = _default;